import { useEffect, useState } from "react"
import CodeTrou from './components/CodeTrou.jsx'
import CodeEditeur from './components/CodeEditeur.jsx'

export default function CodeContainer(props) {
  // LOGIC
  const currentExo = props.currentExo
  const currentExoActivate = props.currentExoActivate
  const validate = props.validate
  const btnColor = props.btnColor

  useEffect(() => {
    currentExoActivate()
  }, [])

  useEffect(() => {
    currentExoActivate()
  }, [currentExo])

  // RENDER
  return (<div id={`d${props.id}`} className="code-container bg-white dark:bg-slate-900 rounded-lg px-6 py-5 ring-1 ring-slate-900/5 shadow-xl mr-10 ml-10 mt-10 blur">
    <div className="mt-10 mb-8 mr-10 w-full  max-w-96 rounded-xl h-full">
      
      
        { props.type == 'carte' && <> 
      <div className="children:my-0 children:!shadow-none children:bg-transparent color-white">
      Voici le plan de vol de Xaquick. <br /> Situer sur la carte, la case sur laquelle il va va arriver. <br />
            {/* CODE */}
        <pre className="db border-l-2 border-l-indigo-500   pl-5 mt-5"><code >
          {props.children}
        </code></pre>
      </div>
        </>}
      
        { props.type == 'code' && <> 
        Ecrire le code permettant à Xaquick de suivre l'itinéraire tracé sur la carte.
      <div className="children:my-0 children:!shadow-none children:bg-transparent color-white min-h-48">
        <CodeEditeur>
          {props.children}
        </CodeEditeur>
        </div>
        </>}
      
        { props.type == 'code-trou' && <> 
        Compléter le code ci-dessous, pour que Xaquick fasse l'itinéraire tracer sur la carte. <br />
      <div className="children:my-0 children:!shadow-none children:bg-transparent color-white min-h-48">
         <br />
         <CodeTrou style={{fonFamily:"Monospace"}} className="bg-gray-100 py-3 pl-1 leading-8">
          {props.children}
          </CodeTrou>
        </div>
        </>}
        <br />
            {/* VALIDATION */}
        <div className="text-right">
          <button
            type="button"
            onClick={validate}
            className={btnColor + " inline-block border border-blue-700 hover:bg-blue-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500 ml-80"} >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-7">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
            </svg>

            <span class="sr-only">Validation</span>
          </button> 
          <div className="pointer-events-none absolute inset-0 rounded-2xl dark:ring-1 dark:ring-white/10 dark:ring-inset" aria-hidden="true"></div>
        </div>
    
    </div>
    {/* PAGINATION */}
    <div className="text-right">{props.id + 1}/{props.totalQuestions}</div >
  </div>

  )
}